import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const calendarHolidaysManagement = createApi({
    reducerPath: "calendarHolidaysManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        calendarHolidaysList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/settings/calendar-holidays`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewCalendarHolidays: builder.mutation({
            query: (holidayId) => ({
                url: `v1/${locale}/settings/calendar-holidays/${holidayId}`,
                method: "GET",
            }),
        }),

        addCalendarHolidays: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/calendar-holidays`,
                method: "POST",
                body: body,
            }),
        }),

        updateCalendarHolidays: builder.mutation({
            query: ({ body, holidayId }) => ({
                url: `v1/${locale}/settings/calendar-holidays/${holidayId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteCalendarHolidays: builder.mutation({
            query: (holidayId) => ({
                url: `v1/${locale}/settings/calendar-holidays/${holidayId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useCalendarHolidaysListMutation,
    useDeleteCalendarHolidaysMutation,
    useAddCalendarHolidaysMutation,
    useViewCalendarHolidaysMutation,
    useUpdateCalendarHolidaysMutation,
} = calendarHolidaysManagement;
